import { useState, useEffect } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { proxyPageImages } from "../lib/imageProxy";
import GeneratedPageContent from "../components/GeneratedPageContent";
import DeactivatedNotice from "../components/DeactivatedNotice";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Rendered when the SPA is loaded on a customer's own custom domain (via the
// Cloudflare Worker proxy). Fetches the page by hostname and renders the
// exact same component as the preview, guaranteeing 1:1 parity.
export default function CustomDomainPage() {
  const [page, setPage] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const host = window.location.hostname.toLowerCase();
    axios.get(`${API}/pages/domain/${host}`)
      .then(res => setPage(proxyPageImages(res.data)))
      .catch(() => setError("Seite nicht gefunden"));
  }, []);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-slate-900 mb-2">Seite nicht gefunden</h1>
          <p className="text-slate-600">Diese Webseite existiert nicht oder wurde entfernt.</p>
        </div>
      </div>
    );
  }

  if (!page) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <Loader2 className="w-8 h-8 text-indigo-600 animate-spin" />
      </div>
    );
  }

  if (page.is_deactivated) return <DeactivatedNotice company={page.company_name} />;
  return <GeneratedPageContent page={page} isPreview={false} />;
}
